import { Box, styled } from '@mui/material'

export const LayoutWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
})

export const ContentWrapper = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '280px 1fr 320px',
  gap: 0,
  flex: 1,
  overflow: 'hidden',
  minHeight: 0,
})

export const SectionWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
  border: `1px solid ${theme.palette.divider}`,
  minHeight: '600px',
}))
